<template>
  <b-row v-if="details">
    <!-- Summary Starts-->
    <b-col cols="12">
      <b-row :class="`details-header-container${details.section? 'details-header-section-exist' : ''}`">
        <b-col
          xl="7"
          md="12"
          sm="12"
        >
          <b-card no-body>
            <div class="bg-light-primary rounded-top text-center" />
            <b-card-header class="align-items-baseline border-bottom">
              <b-row
                class="w-100"
              >
                <b-col class="col-11">
                  <b-card-title
                    class="font-medium-5 text-dark"
                  >
                    <b-link
                      class="text-dark"
                      :href="details.pageUrl"
                      target="_blank"
                      v-html="details.pageTitle"
                    />
                  </b-card-title>
                </b-col>
                <b-col class="col-1">
                  <div
                    v-if="onProgress"
                    class="data-loading d-flex justify-content-center"
                  >
                    <b-spinner
                      class="mt-1"
                      label="Loading"
                    />
                  </div>
                  <b-button
                    v-else
                    variant="dark"
                    class="btn-icon"
                    @click="closeDetails"
                  >
                    <feather-icon
                      icon="XIcon"
                      size="14"
                      class="text-muted cursor-pointer"
                    />
                  </b-button>
                </b-col>
              </b-row>
            </b-card-header>
            <b-row
              v-if="details.image"
              class="mx-1 mt-1 mb-1"
            >
              <b-col
                xl="12"
                md="12"
                sm="12"
              >
                <b-row
                  class="mt-1 d-flex justify-content-around"
                >
                  <b-col
                    v-if="details.image && !isMobile()"
                    cols="2"
                  >
                    <b-img
                      center
                      fluid
                      :src="details.image"
                      alt=""
                      width="100"
                    />
                  </b-col>
                  <b-col
                    :cols="details.image && !isMobile() ? 10 : 12"
                  >
                    <b-row
                      class="mt-1"
                    >
                      <b-col
                        cols="3"
                        class="d-flex justify-content-center"
                      >
                        <b-row
                          class="d-flex justify-content-center"
                        >
                          <b-col class="col-12 font-weight-bolder">
                            {{ $t('Author') }}
                          </b-col>
                          <b-col class="col-12 text-capitalize">
                            {{ details.author }}
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col
                        cols="3"
                        class="d-flex justify-content-center"
                      >
                        <b-row
                          class="d-flex justify-content-center"
                        >
                          <b-col class="col-12 font-weight-bolder">
                            {{ $t('Published') }}
                          </b-col>
                          <b-col class="col-12 ">
                            {{ details.datePublished }}
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col>
                        <b-row
                          class="d-flex justify-content-center"
                        >
                          <b-col class="col-12 font-weight-bolder">
                            {{ $t('Updated') }}
                          </b-col>
                          <b-col class="col-12 ">
                            {{ details.dateModified }}
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col
                        v-if="details.section"
                        cols="3"
                        class="d-flex justify-content-center"
                      >
                        <b-row
                          class="d-flex justify-content-center"
                        >
                          <b-col
                            class="col-12 font-weight-bolder"
                          >
                            {{ $t('Category') }}
                          </b-col>
                          <b-col class="col-12 text-capitalize">
                            {{ details.section }}
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>

                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <!-- Engagement Starts -->
        <b-col
          xl="5"
          md="12"
          sm="12"
          class="engagement-container"
        >
          <b-card no-body>
            <div class="bg-light-primary rounded-top" />
            <b-card-header class="align-items-baseline border-bottom bg-success rounded-top">
              <div>
                <b-card-title
                  class="font-medium-5 text-light"
                >
                  {{ $t('Engagement') }}
                </b-card-title>
              </div>
            </b-card-header>
            <b-card-body class="mt-1">
              <b-row class="d-flex justify-content-around">
                <b-col class="d-flex justify-content-center">
                  <b-row>
                    <b-col class="col-12 font-weight-bolder d-flex justify-content-center">
                      {{ $t('Readability') }}
                    </b-col>
                    <b-col class="col-12 text-capitalize d-flex justify-content-center">
                      <b-media no-body>
                        <b-media-aside
                          class="ml-0 mr-1"
                        >
                          <b-avatar
                            size="32"
                            variant="light-warning"
                          >
                            <feather-icon
                              size="20"
                              icon="BookOpenIcon"
                            />
                          </b-avatar>
                        </b-media-aside>
                        <b-media-body class="my-auto">
                          <b-card-text
                            v-if="details.galleryReadability"
                            class="mb-0 font-medium-5 font-weight-bold"
                          >
                            {{ details.galleryReadability }}
                          </b-card-text>
                          <b-card-text
                            v-else
                            class="mb-0 font-medium-5 font-weight-bold"
                          >
                            {{ details.readability }}
                          </b-card-text>
                        </b-media-body>
                      </b-media>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="d-flex justify-content-center">
                  <b-row>
                    <b-col class="col-12 font-weight-bolder d-flex justify-content-center">
                      {{ $t('Recirculation') }}
                    </b-col>
                    <b-col class="col-12 d-flex justify-content-center">
                      <b-media no-body>
                        <b-media-aside
                          class="ml-0 mr-1"
                        >
                          <b-avatar
                            size="32"
                            variant="light-secondary"
                          >
                            <feather-icon
                              size="20"
                              icon="RotateCwIcon"
                            />
                          </b-avatar>
                        </b-media-aside>
                        <b-media-body class="my-auto">
                          <b-card-text class="mb-0 font-medium-5 font-weight-bold">
                            {{ details.recirculation }}
                          </b-card-text>
                        </b-media-body>
                      </b-media>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="d-flex justify-content-center">
                  <b-row>
                    <b-col class="col-12 font-weight-bolder d-flex justify-content-center">
                      {{ $t('Average Time') }}
                    </b-col>
                    <b-col class="col-12 d-flex justify-content-center">
                      <b-media no-body>
                        <b-media-aside
                          class="ml-0 mr-1"
                        >
                          <b-avatar
                            size="32"
                            variant="light-success"
                          >
                            <feather-icon
                              size="20"
                              icon="WatchIcon"
                            />
                          </b-avatar>
                        </b-media-aside>
                        <b-media-body class="my-auto">
                          <b-card-text class="mb-0 font-medium-5 font-weight-bold">
                            {{ details.avgPageDuration }}
                          </b-card-text>
                        </b-media-body>
                      </b-media>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <!-- Engagement Ends -->
      </b-row>
    </b-col>
    <!-- Summary Ends-->

    <!-- User Interaction Starts-->
    <b-col
      xl="6"
      md="12"
      sm="12"
    >
      <b-card no-body>
        <b-card-header class="border-bottom">
          <b-card-title class="font-weight-bold text-secondary font-medium-3">
            <span>{{ $t('User Interactions') }}</span>
          </b-card-title>
        </b-card-header>
        <div>
          <!-- Stats Card Vertical -->
          <b-row class="match-height">
            <b-col
              xl="6"
              md="6"
              sm="12"
              class="border-right"
            >
              <span class="text-center mt-1 font-medium-1 font-weight-bold text-dark">
                {{ $t('Views') }}
              </span>
              <statistic-card-vertical
                color="primary"
                icon="EyeIcon"
                :statistic="details.pvCount"
                statistic-title=""
              />
            </b-col>
            <b-col
              v-if="details.galleryViewAvg && details.gallery_quantity"
              xl="6"
              md="6"
              sm="12"
            >
              <span class="text-center mt-1 font-medium-1 font-weight-bold text-dark">
                {{ $t('Avg. Scroll') }}
              </span>
              <statistic-card-vertical
                color="warning"
                icon="BookOpenIcon"
                :statistic="details.galleryViewAvg + ` / ` + details.gallery_quantity"
                statistic-title=""
              />
            </b-col>
            <b-col
              v-else
              xl="6"
              md="6"
              sm="12"
            >
              <span class="text-center mt-1 font-medium-1 font-weight-bold text-dark">
                {{ $t('Avg. Scroll') }}
              </span>
              <statistic-card-vertical
                color="warning"
                icon="BookOpenIcon"
                class="font-medium-1 font-weight-bold text-dark"
                :statistic="details.avgScrollPercentage + `%`"
                statistic-title=""
              />
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-col>
    <!-- User Interaction Ends-->

    <!-- Loyalties Starts-->
    <b-col
      v-if="loyaltiesData"
      xl="6"
      md="12"
      sm="12"
    >
      <news-details-loyalty
        :loyalties-data="loyaltiesData"
      />
    </b-col>
    <!-- Loyalties Ends-->

    <!-- Sources Starts-->
    <b-col
      v-if="sourcesData"
      xl="6"
      md="12"
      sm="12"
    >
      <news-details-info-group
        :sources-data="sourcesData"
      />
    </b-col>
    <!-- Sources Ends-->

    <!-- Devices Starts-->
    <b-col
      v-if="deviceViewData"
      xl="6"
      md="12"
      sm="12"
    >
      <news-details-bar-chart
        :bar-data="deviceViewData"
      />
    </b-col>
    <!-- Devices Ends-->

    <!-- Scrolls Starts -->
    <b-col
      xl="6"
      md="12"
      sm="12"
    >
      <news-details-bar-chart
        v-if="scrollsData"
        :bar-data="scrollsData"
      />
      <news-details-bar-chart
        v-if="galleryViewData"
        :bar-data="galleryViewData"
      />
    </b-col>
    <!-- Scrolls Ends -->

    <!-- Durations Starts -->
    <b-col
      v-if="durationsData"
      xl="6"
      md="12"
      sm="12"
    >
      <news-details-bar-chart
        :bar-data="durationsData"
      />
    </b-col>
    <!-- Duration Ends -->

    <!-- Videos Starts-->
    <b-col
      v-if="avData"
      xl="12"
      md="12"
      sm="12"
    >
      <news-details-video
        :av-data="avData"
      />
    </b-col>
    <!-- Videos Ends-->

    <b-col
      xl="12"
      md="12"
      sm="12"
    >
      <b-row>
        <b-col
          xl="6"
          md="12"
          sm="12"
        >
          <!-- Referrers & Origin Referrers Starts-->
          <b-col
            v-if="referrersData && referrersData.length"
            xl="12"
            md="12"
            sm="12"
          >
            <news-details-referrer
              :referrers-data="referrersData"
            />
          </b-col>

          <b-col
            v-if="originData && originData.length"
            xl="12"
            md="12"
            sm="12"
          >
            <news-details-origin-referrer
              :origin-data="originData"
            />
          </b-col>
          <!--  Referrers & Origin Referrers Ends-->

          <!-- Referrers Utms & Origin Referrers Utms Starts-->
          <b-col
            v-if="referrerUtmsData && referrerUtmsData.length"
            xl="12"
            md="12"
            sm="12"
          >
            <news-details-utm-referrer
              :referrer-utms-data="referrerUtmsData"
            />
          </b-col>

          <b-col
            v-if="originUtmsData && originUtmsData.length"
            xl="12"
            md="12"
            sm="12"
          >
            <news-details-origin-utm-referrer
              :origin-utms-data="originUtmsData"
            />
          </b-col>
          <!--  Referer Utms & Origin Referrers Utms Ends-->
        </b-col>
        <b-col
          xl="6"
          md="12"
          sm="12"
        >
          <!-- Zone Starts-->
          <b-col
            v-if="zonesData"
            xl="12"
            md="12"
            sm="12"
          >
            <news-details-zone
              :zones-data="zonesData"
            />
          </b-col>
          <!-- Zone Ends-->
          <!-- Generated Traffic Starts-->
          <b-col
            v-if="generatedTrafficData"
            xl="12"
            md="12"
            sm="12"
          >
            <news-details-generated-page
              :gp-data="generatedTrafficData"
            />
          </b-col>
          <!-- Generated Pages Ends-->
        </b-col>
      </b-row>
    </b-col>

  </b-row>
</template>

<script>
import {
    BRow, BCol, BCard, BCardTitle, BButton, BCardHeader, BCardText, BImg, BCardBody, BMedia, BMediaAside, BAvatar, BMediaBody, BLink, BSpinner,
} from 'bootstrap-vue'
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
import NewsDetailsBarChart from '@/views/components/details/charts/NewsDetailsBarChart.vue'
import NewsDetailsInfoGroup from '@/views/components/details/charts/NewsDetailsInfoGroup.vue'
import NewsDetailsReferrer from '@/views/components/details/tables/NewsDetailsReferrer.vue'
import NewsDetailsOriginReferrer from '@/views/components/details/tables/NewsDetailsOriginReferrer.vue'
import NewsDetailsUtmReferrer from '@/views/components/details/tables/NewsDetailsUtmReferrer.vue'
import NewsDetailsOriginUtmReferrer from '@/views/components/details/tables/NewsDetailsOriginUtmReferrer.vue'
import NewsDetailsLoyalty from '@/views/components/details/tables/NewsDetailsLoyalty.vue'
import NewsDetailsZone from '@/views/components/details/tables/NewsDetailsZone.vue'
import NewsDetailsGeneratedPage from '@/views/components/details/tables/NewsDetailsGeneratedPage.vue'
import NewsDetailsVideo from '@/views/components/details/tables/NewsDetailsVideo.vue'

// eslint-disable-next-line import/no-extraneous-dependencies,no-unused-vars
const moment = require('moment')

export default {
    components: {
        NewsDetailsBarChart,
        NewsDetailsInfoGroup,
        StatisticCardVertical,
        NewsDetailsReferrer,
        NewsDetailsUtmReferrer,
        NewsDetailsOriginReferrer,
        NewsDetailsOriginUtmReferrer,
        NewsDetailsLoyalty,
        NewsDetailsZone,
        NewsDetailsGeneratedPage,
        NewsDetailsVideo,
        BRow,
        BCol,
        BCard,
        BCardTitle,
        BButton,
        BCardHeader,
        BCardText,
        BImg,
        BCardBody,
        BMedia,
        BMediaAside,
        BAvatar,
        BMediaBody,
        BLink,
        BSpinner,
    },
    props: {
        details: {
            type: Object,
            default: () => {},
        },
        pageAvg: {
            type: Object,
            default: () => {},
        },
        onProgress: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            scrollsData: null,
            galleryViewData: null,
            deviceViewData: null,
            sourcesData: null,
            referrersData: null,
            referrerUtmsData: null,
            originData: null,
            originUtmsData: null,
            loyaltiesData: null,
            zonesData: null,
            generatedTrafficData: null,
            durationsData: null,
            avData: null,
        }
    },
    watch: {
        details() {
            this.initDetails()
        },
    },
    created() {
        this.initDetails()
    },
    methods: {
        initDetails() {
            if (this.details) {
                // Devices Starts
                let deviceListTitles = null
                if (this.details.devices) {
                    if (this.details.devices) {
                        deviceListTitles = JSON.parse(this.details.devices)
                    }
                    if (deviceListTitles) {
                        deviceListTitles.sort((a, b) => ((a.d - b.d) ? 1 : -1))
                        let deviceViewsTotal = 0
                        deviceListTitles.forEach(obj => {
                            deviceViewsTotal += obj.dc
                        })

                        const deviceList = {
                            desktop: {
                                left: 'desktop',
                                bar: 0,
                                right: 0,
                            },
                            mobile: {
                                left: 'mobile',
                                bar: 0,
                                right: 0,
                            },
                            tablet: {
                                left: 'tablet',
                                bar: 0,
                                right: 0,
                            },
                        }
                        deviceListTitles.forEach(obj => {
                            deviceList[obj.d] = {
                                left: `${obj.d}`,
                                // eslint-disable-next-line no-mixed-operators
                                bar: Math.round(obj.dc / deviceViewsTotal * 100),
                                right: obj.dc,
                            }
                        })
                        this.deviceViewData = {
                            title: 'Devices',
                            tableLeftTitle: 'Type',
                            tableRightTitle: 'Views',
                            list: deviceList,
                        }
                    }
                } else {
                    this.deviceViewData = null
                }
                // Devices End

                // Sources Starts
                let sources = null
                if (this.details.sources) {
                    sources = JSON.parse(this.details.sources)
                }

                if (sources) {
                    sources.sort((a, b) => a.s - b.s)
                    // calculate Total Number Of Views to get the percentage of each source
                    let sourcesViewsTotal = 0
                    sources.forEach(obj => {
                        sourcesViewsTotal += obj.sc
                    })

                    const sourcesViewsList = {
                        web: {
                            sourceTitle: 'web',
                            sourceValue: 0,
                            sourcePercentage: 0,
                            icon: 'AlertCircleIcon',
                            color: 'light-danger',
                            customClass: 'mb-2 mb-xl-0',
                        },
                        amp: {
                            sourceTitle: 'amp',
                            sourceValue: 0,
                            sourcePercentage: 0,
                            icon: 'AlertCircleIcon',
                            color: 'light-danger',
                            customClass: 'mb-2 mb-xl-0',
                        },
                    }

                    // eslint-disable-next-line no-unused-vars
                    let icon = ''; let color = ''; let customClass = ''

                    sources.forEach(obj => {
                        switch (obj.s) {
                        case 'web':
                            color = 'light-primary'
                            icon = 'GlobeIcon'
                            customClass = 'mb-2 mb-xl-0'
                            break
                        case 'amp':
                            color = 'light-info'
                            icon = 'ActivityIcon'
                            customClass = 'mb-2 mb-sm-0'
                            break
                        case 'iosApp':
                            color = 'light-success'
                            icon = 'SmartphoneIcon'
                            customClass = 'mb-2 mb-sm-0'
                            break
                        case 'androidApp':
                            color = 'light-warning'
                            icon = 'SquareIcon'
                            customClass = 'mb-2 mb-sm-0'
                            break
                        default:
                            icon = 'AlertCircleIcon'
                            color = 'light-danger'
                            customClass = 'mb-2 mb-xl-0'
                        }
                        sourcesViewsList[obj.s] = {
                            sourceTitle: `${obj.s}`,
                            sourceValue: obj.sc,
                            // eslint-disable-next-line no-mixed-operators
                            sourcePercentage: Math.round(obj.sc / sourcesViewsTotal * 100),
                            color,
                            icon,
                            customClass,
                        }
                    })

                    this.sourcesData = {
                        title: 'Sources',
                        tableLeftTitle: 'Type',
                        tableRightTitle: 'Views',
                        list: sourcesViewsList,
                    }
                } else {
                    this.sourcesData = null
                }
                // Sources End

                // GalleryViews
                let galleryViews = null
                if (this.details.galleryViews) {
                    galleryViews = JSON.parse(this.details.galleryViews)
                }
                if (galleryViews) {
                    const galleryViewsList = {
                        25: {
                            left: '25% depth',
                            bar: 0,
                            right: 0,
                        },
                        50: {
                            left: '50% depth',
                            bar: 0,
                            right: 0,
                        },
                        75: {
                            left: '75% depth',
                            bar: 0,
                            right: 0,
                        },
                        100: {
                            left: '100% depth',
                            bar: 0,
                            right: 0,
                        },
                    }

                    // eslint-disable-next-line no-restricted-syntax
                    for (const [key] of Object.entries(galleryViewsList)) {
                        let elementExist = false
                        galleryViews.forEach(obj => {
                            // eslint-disable-next-line radix
                            if (parseInt(key) === parseInt(obj.gx)) {
                                elementExist = true
                            }
                        })
                        if (!elementExist) {
                            galleryViews.push({
                                // eslint-disable-next-line radix
                                gx: parseInt(key),
                                gy: 0,
                            })
                        }
                    }

                    galleryViews.sort((a, b) => a.gx - b.gx)

                    let galleryViewsTotal = 0
                    galleryViews.forEach(obj => {
                        galleryViewsTotal += obj.gy
                    })

                    let viewsTotalDes = galleryViewsTotal
                    let prevObject = null
                    galleryViews.forEach(obj => {
                        if (prevObject) {
                            viewsTotalDes -= prevObject.gy
                        }
                        galleryViewsList[obj.gx] = {
                            left: `${obj.gx}% depth`,
                            // eslint-disable-next-line no-mixed-operators
                            bar: Math.round(viewsTotalDes / galleryViewsTotal * 100),
                            right: viewsTotalDes,
                        }
                        prevObject = obj
                    })

                    this.galleryViewData = {
                        title: 'Gallery Depth',
                        tableLeftTitle: 'Scrolled',
                        tableRightTitle: 'Views',
                        list: galleryViewsList,
                    }
                    this.scrollsData = null
                } else if (this.details.scrolls) {
                    const scrolls = JSON.parse(this.details.scrolls)
                    const scrollsList = {
                        25: {
                            left: '25% depth',
                            bar: 0,
                            right: 0,
                        },
                        50: {
                            left: '50% depth',
                            bar: 0,
                            right: 0,
                        },
                        75: {
                            left: '75% depth',
                            bar: 0,
                            right: 0,
                        },
                        100: {
                            left: '100% depth',
                            bar: 0,
                            right: 0,
                        },
                    }

                    // eslint-disable-next-line no-restricted-syntax
                    for (const [key] of Object.entries(scrollsList)) {
                        let elementExist = false
                        scrolls.forEach(obj => {
                            // eslint-disable-next-line radix
                            if (parseInt(key) === parseInt(obj.sx)) {
                                elementExist = true
                            }
                        })
                        if (!elementExist) {
                            scrolls.push({
                                // eslint-disable-next-line radix
                                sx: parseInt(key),
                                sy: 0,
                            })
                        }
                    }

                    scrolls.sort((a, b) => a.sx - b.sx)

                    let scrollUserTotal = 0
                    scrolls.forEach(obj => {
                        scrollUserTotal += obj.sy
                    })
                    let prevObject = null
                    let viewsTotalDes = scrollUserTotal

                    scrolls.forEach(obj => {
                        if (prevObject) {
                            viewsTotalDes -= prevObject.sy
                        }
                        // eslint-disable-next-line radix
                        scrollsList[obj.sx] = {
                            left: `${obj.sx}% depth`,
                            // eslint-disable-next-line no-mixed-operators
                            bar: Math.round(viewsTotalDes / scrollUserTotal * 100),
                            right: viewsTotalDes,
                        }
                        prevObject = obj
                    })

                    this.scrollsData = {
                        title: 'Scroll depth',
                        tableLeftTitle: 'Scrolled',
                        tableRightTitle: 'Views',
                        list: scrollsList,
                    }
                    this.galleryViewData = null
                }

                // Referrers Starts
                if (this.details.referers) {
                    this.referrersData = this.details.referers
                } else {
                    this.referrersData = null
                }
                // Referrers End

                // Referrer Utms Starts
                if (this.details.refererUtms) {
                    this.referrerUtmsData = this.details.refererUtms
                } else {
                    this.referrerUtmsData = null
                }
                // Referrer Utms End

                // Origin Referrers Starts
                if (this.details.originReferers) {
                    this.originData = this.details.originReferers
                } else {
                    this.originData = null
                }
                // Origin Referrers End

                // Origin Referrer Utms Starts
                if (this.details.originUtmsReferers) {
                    this.originUtmsData = this.details.originUtmsReferers
                } else {
                    this.originUtmsData = null
                }
                // Origin Referrer Utms End

                // Loyalties Starts
                let loyalties = null
                if (this.details.loyalties) {
                    loyalties = JSON.parse(this.details.loyalties)
                    if (loyalties) {
                        const loyaltiesList = {}

                        loyalties.forEach(obj => {
                            loyaltiesList[obj.visitorLoyalty] = {
                                visitorType: obj.visitorLoyalty,
                                visitorCount: obj.total,
                            }
                        })

                        this.loyaltiesData = {
                            title: 'Visitor Loyalty',
                            tableLeftTitle: 'Visitor Type',
                            tableRightTitle: 'Count',
                            list: loyaltiesList,
                        }
                    }
                } else {
                    this.loyaltiesData = null
                }

                // Loyalties End

                // Zones Starts
                let zones = null
                if (this.details.zones.length) {
                    zones = this.details.zones

                    if (zones) {
                        zones.sort((a, b) => ((a.zone_value_count - b.zone_value_count) ? 1 : -1))

                        const zonesList = {}

                        let countZonePosition = 0
                        zones.forEach(obj => {
                            const zonePosition = obj.zone_value || null
                            if (zonePosition) {
                                countZonePosition += 1
                            }
                            zonesList[obj.zone_name] = {
                                zoneName: obj.zone_name,
                                zonePosition,
                                zoneCount: obj.zone_value_count,
                            }
                        })

                        this.zonesData = {
                            title: 'Zones',
                            tableLeftTitle: 'Zone Name',
                            tableMiddleTitle: countZonePosition ? 'Position' : null,
                            tableRightTitle: 'Count',
                            list: zonesList,
                        }
                    }
                } else {
                    this.zonesData = null
                }
                // Zones End

                // Generated Pages Starts
                let generatedTraffic = null
                // TODO: ELIMINATE generatedPageUrls AS SOURCE AND IT FROM IF SEQUENCE ONCE THE CODE IS MERGED TO LIVE
                // TODO: UPDATE LIVE PAGE VIEW DETAIL QUERY AND CHANGE generatedPageUrls TO generatedTraffic AS SOON AS THE CODE MERGED TO LIVE
                if (this.details.generatedTraffic) {
                    generatedTraffic = JSON.parse(this.details.generatedTraffic)
                } else if (this.details.generatedPageUrls) {
                    generatedTraffic = JSON.parse(this.details.generatedPageUrls)
                }

                if (generatedTraffic) {
                    generatedTraffic.sort((a, b) => (b.total - a.total))

                    const generatedTrafficList = {}
                    generatedTraffic.forEach(obj => {
                        generatedTrafficList[obj.referrer] = {
                            pageUrl: obj.referrer,
                            totalLanding: obj.totalLanding,
                            totalInfinite: obj.totalInfinite,
                            total: obj.total,
                        }
                    })

                    this.generatedTrafficData = {
                        title: 'Generated Pages',
                        tableLeftTitle: 'Page URL',
                        tableMiddleTitle: 'Total',
                        tableRightTitle: 'Infinite',
                        totalGenerated: this.details.generatedTrafficTotal || null,
                        totalGeneratedIFrame: this.details.generatedTrafficNoIScrollTotal || null,
                        list: generatedTrafficList,
                    }
                } else {
                    this.generatedTrafficData = null
                }
                // Generated Pages End

                // Duration Starts

                if (this.details.durations) {
                    const durations = JSON.parse(this.details.durations)
                    const durationsList = {
                        30: {
                            left: '0-30',
                            bar: 0,
                            right: 0,
                        },
                        60: {
                            left: '31-60',
                            bar: 0,
                            right: 0,
                        },
                        90: {
                            left: '61-90',
                            bar: 0,
                            right: 0,
                        },
                        '> 90': {
                            left: '> 90',
                            bar: 0,
                            right: 0,
                        },
                    }

                    durations.sort((a, b) => a.dx - b.dx)

                    let durationsTotal = 0
                    durations.forEach(obj => {
                        durationsTotal += obj.dy
                    })

                    let viewsTotalDes = durationsTotal
                    let prevObject = null

                    durations.forEach(obj => {
                        if (prevObject) {
                            viewsTotalDes -= prevObject.dy
                        }
                        // eslint-disable-next-line radix
                        // noinspection CommaExpressionJS
                        if (typeof durationsList[obj.dx] !== 'undefined') {
                            durationsList[obj.dx] = {
                                left: `${obj.dx}s`,
                                // eslint-disable-next-line no-mixed-operators
                                bar: Math.round(viewsTotalDes / durationsTotal * 100),
                                right: viewsTotalDes,
                            }
                        } else {
                            durationsList['> 90'] = {
                                left: '> 90s',
                                // eslint-disable-next-line no-mixed-operators
                                bar: durationsList['> 90'].bar + obj.dy,
                                right: durationsList['> 90'].right + obj.dy,
                            }
                        }
                        prevObject = obj
                    })

                    durationsList['> 90'] = {
                        left: '> 90s',
                        // eslint-disable-next-line no-mixed-operators
                        bar: Math.round(durationsList['> 90'].bar / durationsTotal * 100),
                        right: durationsList['> 90'].right,
                    }

                    this.durationsData = {
                        title: 'Durations Breakdown',
                        tableLeftTitle: 'Time',
                        tableRightTitle: 'Views',
                        list: durationsList,
                    }
                } else {
                    this.durationsData = null
                }
                // Duration Ends

                // Video Starts
                if (this.details.videoData.length) {
                    this.avData = {
                        title: 'Videos',
                        labelTitle: 'Label',
                        avgTimeTitle: 'Avg. Time',
                        avgTimeDisplayTitle: 'Avg. Display Time',
                        completedTitle: 'Completed',
                        completedRatioTitle: 'Completed Ratio',
                        durationTitle: 'Duration',
                        playedTitle: 'Played',
                        playedRatioTitle: 'Played Ratio',
                        posterTitle: 'Poster',
                        list: this.details.videoData,
                    }
                } else {
                    this.avData = null
                }
                // Video End
            }
        },
        isMobile() {
            return window.innerWidth < 768
        },
        closeDetails() {
            this.$emit('closeDetails')
        },
    },
}
</script>
